module.exports = __webpack_public_path__ + "img/paihangbang.ea5c038d.png";